/**
 * @namespace Fullscreen
 * @aka SWR.Fullscreen
 * NOTE: übernommen von DASDING
 */
SWR.Fullscreen = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'Fullscreen';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_TOGGLE: '[data-toggle="fullscreen"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Fullscreen = function () {

    function Fullscreen(element) {
      COMMON.Utils._classCallCheck(this, Fullscreen);
      var self = this;
      /**
       * @protected
       */
      self.element = element;
    }

    Fullscreen.prototype._requestFullscreen = function _requestFullscreen($target) {
      if ('undefined' !== typeof $target.get(0)) $target = $target.get(0);

      if ($target.requestFullscreen) {
        $target.requestFullscreen();
      } else if ($target.webkitRequestFullscreen) {
        $target.webkitRequestFullscreen();
      } else if ($target.webkitEnterFullscreen) {
        $target.webkitEnterFullscreen();
      } else if ($target.mozRequestFullScreen) {
        $target.mozRequestFullScreen();
      } else if ($target.msRequestFullscreen) {
        $target.msRequestFullscreen();
      } else {
        console.debug('Fullscreen API is not supported.');
      }
    };

    Fullscreen.prototype._exitFullscreen = function _exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else {
        console.debug('Fullscreen API is not supported.');
      }
    };

    Fullscreen.prototype.toggleFullscreen = function toggleFullscreen(element) {
      var self = this;
      var target =  $(self.element).data('target');

      if (!self._isFullscreen()) {
        self._requestFullscreen($(target));
      } else {
        self._exitFullscreen();
      }
    };

    Fullscreen.prototype._isFullscreen = function _isFullscreen() {
      return document.fullscreenElement ||  document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement
    };

    // static
    Fullscreen._jQueryInterface = function _jQueryInterface(action) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        if (!data) {
          data = new Fullscreen(this);
          $(this).data(DATA_KEY, data);
        }
        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return Fullscreen;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();
    Fullscreen._jQueryInterface.call($(this), 'toggleFullscreen');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Fullscreen._jQueryInterface;
  $.fn[NAME].Constructor = Fullscreen;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Fullscreen._jQueryInterface;
  };

  return Fullscreen;

})(window.jQuery);
